import RouterView from '@/page/main/DefaultRouterView'
// 工程列表
import List from '@/page/project/list'
// 微信项目(A类)列表
import AList from '@/page/project/aList'
// 微信项目(B类)列表
import SList from '@/page/project/sList'
// 进度总览
import StatisticsList from '@/page/project/statisticslist'
// 支付总览
import PayOverviewList from '@/page/project/payOverviewList'
// 项目详情
import Detail from '@/page/project/detail'

// 创建工程
import Create from '@/page/project/formLayout/create'
// 立项批文
import CreateSetup from '@/page/project/formLayout/createSetup'
// 招标控制价
import CreateInvite from '@/page/project/formLayout/createInvite'
// 预算（招标控制价）（微型项目）
import CreateBudget from '@/page/project/formLayout/createBudget'
// 项目招标文件审核会签
import CreateInviteApproval from '@/page/project/formLayout/createInviteApproval'
// 招标情况填录（开标结果）
import InviteResult from '@/page/project/formLayout/inviteResult'
// 合同会签
import CreateContractApproval from '@/page/project/formLayout/createContractApproval'
// 合同备案
import CreateContractRecordApproval from '@/page/project/formLayout/CreateContractRecordApproval'

// 支付审核
import CreateMoneyApproval from '@/page/project/formLayout/createMoneyApproval'
// 支付审批
import CreatePayApproval from '@/page/project/formLayout/createPayApproval'
// import CreateMoneyPayApproval from '@/page/project/createMoneyPayApproval'
// import CreateSettlement from '@/page/project/createSettlement'
// import CreateSettlementPay from '@/page/project/createSettlementPay'
// import CreateTechContact from '@/page/project/createTechContact'

// 项目开工登记
import CreateStart from '@/page/project/formLayout/createStart'
// 项目竣工验收记录
import CreateEnd from '@/page/project/formLayout/createEnd'
// 项目形象进度填报登记
import CreateProgress from '@/page/project/formLayout/createProgress'
// 项目前期情况登记
import UpdateInfo from '@/page/project/formLayout/updateInfo'
// 修改项目预警时间审批表
import CreateUpdateTime from '@/page/project/formLayout/createUpdateTime'
// 项目结案登记
import endRegister from '@/page/project/formLayout/endRegister'


// 项目废弃审批
import CreateDiscard from '@/page/project/formLayout/createDiscard'


export default {
  path: '/Project',
  component: RouterView,
  children: [{
    path: 'CreateDiscard',
    meta: {
      type: ['project', 'list'],
      title: '项目废弃审批'
    },
    component: CreateDiscard
  }, {
      path: 'EndRegister/:projectId/:applyId?',
      meta: {
        type: ['project', 'list'],
        title: '项目结案登记表'
      },
      component: endRegister
    }, {
      path: 'CreateUpdateTime/:projectId/:applyId?',
      meta: {
        type: ['project', 'list'],
        title: '修改项目预警时间审批表'
      },
      component: CreateUpdateTime
    }, {
      path: 'UpdateInfo/:projectId',
      meta: {
        type: ['project', 'list'],
        title: '项目前期情况登记'
      },
      component: UpdateInfo
    },
    {
      path: 'CreateStart/:projectId',
      meta: {
        type: ['project', 'list'],
        title: '开工登记'
      },
      component: CreateStart
    },
    {
      path: 'CreateEnd/:projectId',
      meta: {
        type: ['project', 'list'],
        title: '竣工验收登记'
      },
      component: CreateEnd
    },
    {
      path: 'CreateProgress/:projectId',
      meta: {
        type: ['project', 'list'],
        title: '形象进度填报'
      },
      component: CreateProgress
    },
    {
      path: 'Create/:applyId?',
      meta: {
        type: ['project', 'create'],
        title: '项目申请'
      },
      component: Create
    },
    {
      path: 'CreateSetup/:projectId',
      meta: {
        type: ['project', 'list'],
        title: '提交项目立项结果'
      },
      component: CreateSetup
    },
    {
      path: 'CreateInvite/:projectId/:applyId?',
      meta: {
        type: ['project', 'list'],
        title: '招标控制价审批'
      },
      component: CreateInvite
    },
    {
      path: 'CreateBudget/:projectId/:applyId?',
      meta: {
        type: ['project', 'list'],
        title: '预算（招标控制价）审批'
      },
      component: CreateBudget
    },
    {
      path: 'CreateInviteApproval/:projectId/:applyId?',
      meta: {
        type: ['project', 'list'],
        title: '招标文件审核会签'
      },
      component: CreateInviteApproval
    },
    {
      path: 'InviteResult/:relateId',
      meta: {
        type: ['project', 'list'],
        title: '招标情况(开标结果)填录'
      },
      component: InviteResult
    },
    {
      path: 'CreateContractApproval/:projectId/:applyId?',
      meta: {
        type: ['project', 'list'],
        title: '合同会签'
      },
      component: CreateContractApproval
    },
    {
      path: 'CreateContractRecordApproval/:projectId/:applyId?',
      meta: {
        type: ['project', 'list'],
        title: '合同备案审批'
      },
      component: CreateContractRecordApproval
    },
    {
      path: 'CreateMoneyApproval/:projectId/:applyId?',
      meta: {
        type: ['project', 'list'],
        title: '项目进度款审批'
      },
      component: CreateMoneyApproval
    },
    // {
    //   path: 'CreateMoneyPayApproval/:projectId/:applyId?',
    //   meta: {
    //     type: ['project', 'list'],
    //     title: '项目进度款支付审批'
    //   },
    //   component: CreateMoneyPayApproval
    // },
    {
      path: 'CreatePayApproval/:projectId/:applyId?',
      meta: {
        type: ['project', 'list'],
        title: '项目付款审批'
      },
      component: CreatePayApproval
    },
    // {
    //   path: 'CreateSettlementPay/:projectId/:applyId?',
    //   meta: {
    //     type: ['project', 'list'],
    //     title: '项目结算款支付审批'
    //   },
    //   component: CreateSettlementPay
    // },
    // {
    //   path: 'CreateTechContact/:projectId',
    //   meta: {
    //     type: ['project', 'list'],
    //     title: '工程技术/洽商联系单'
    //   },
    //   component: CreateTechContact
    // },
    {
      path: 'List',
      meta: {
        type: ['project', 'list'],
        title: '项目列表'
      },
      component: List
    },{
      path: 'S/List',
      meta: {
        type: ['project', 'slist'],
        title: '微型项目(B类)列表'
      },
      component: SList
    },{
      path: 'A/List',
      meta: {
        type: ['project', 'alist'],
        title: '微型项目(A类)列表'
      },
      component: AList
    },
    {
      path: 'Statistics/List',
      meta: {
        type: ['project', 'statistics'],
        title: '工程项目进度总览'
      },
      component: StatisticsList
    },
    {
      path: 'PayOverview/List',
      meta: {
        type: ['project', 'pay'],
        title: '工程项目款项/支付总览'
      },
      component: PayOverviewList
    },
    // 
    {
      path: 'Detail/:id',
      meta: {
        type: ['project', 'list'],
        title: '项目详情'
      },
      component: Detail
    }
  ]
}


// WEBPACK FOOTER //
// ./src/router/project.js